import { useMediaQuery } from '@mui/material';

import { useOptionalChartSettings } from 'contexts/chart/chart-settings-context';

// TODO: The returned value must not change while a chart is mounted. In MUI X Charts 9.15 (still the case in 9.16),
// switching skipAnimation from false to true mid-animation calls Transition.finish(), which writes the old target
// position one frame late. A re-render in that frame gets overwritten, leaving line marks, bars or arcs at stale
// positions (bug #2043552). We used to skip animation after the first render. Now each chart keeps one value, read at
// mount. The bug is in MUI (useAnimateInternal / Transition), so recheck this when upgrading @mui/x-charts.
export const useChartAnimation = (skipAnimation?: boolean): boolean | undefined => {
  const settingsState = useOptionalChartSettings();
  const prefersReducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)', { noSsr: true });
  const settings = settingsState?.settings;

  if (prefersReducedMotion || settings?.prefersReducedMotion) return true;

  return skipAnimation ?? (settings ? !settings.animationsEnabled : undefined);
};
